var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
    'Chat-entry': true,
    'Chat-entry--is-unhandled': !_vm.messageEntry.isHandled,
    'Chat-entry--is-me': _vm.isMe,
    'Chat-entry--first': _vm.isFirst
  }},[_c('h4',{staticClass:"Chat-entry__posted-at"},[_vm._v(_vm._s(_vm.postedAtFormatted))]),_c('div',{staticClass:"Chat-entry__content"},[_c('div',{staticClass:"Chat-entry__inner-bubble"},[_c('div',{staticClass:"Chat-entry__sender"},[_vm._v(_vm._s(_vm.messageEntry.from))]),_c('div',{staticClass:"Chat-entry__message"},[_vm._v(_vm._s(_vm.messageEntry.message))])]),(
        !_vm.messageEntry.isHandled &&
          !_vm.isSubmitLoading &&
          !_vm.disabled &&
          !_vm.isApplicant
      )?_c('a',{staticClass:"Chat-entry__mark-as-handled",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.markAsHandled($event)}}},[_vm._v("Markera som löst")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }